import { render, staticRenderFns } from "./CardValue.vue?vue&type=template&id=93aa917a&scoped=true"
import script from "./CardValue.vue?vue&type=script&lang=js"
export * from "./CardValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93aa917a",
  null
  
)

export default component.exports